import React from 'react'
import '../estilos/QuieneSomos.css'
import { useTranslation } from 'react-i18next'

function CorporateValues() {
  const { t } = useTranslation();

  const valores = [
    {
      titulo: t('valores_liderazgo'),
      icono: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      descripcion: t('valores_liderazgo_desc'),
    },
    {
      titulo: t('valores_integridad'),
      icono: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/>
          <path d="m9 12 2 2 4-4"/>
        </svg>
      ),
      descripcion: t('valores_integridad_desc'),
    },
    {
      titulo: t('valores_dinamismo'),
      icono: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z"/>
        </svg>
      ),
      descripcion: t('valores_dinamismo_desc'),
    },
    {
      titulo: t('valores_fortaleza'),
      icono: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18.36 6.64a9 9 0 1 1-12.73 0"/>
          <line x1="12" y1="2" x2="12" y2="12"/>
        </svg>
      ),
      descripcion: t('valores_fortaleza_desc'),
    },
  ]

  return (
    <section className="corporate-values">
      <h2 className="corporate-values-title">{t('quienes_valores')}</h2>
      <div className="corporate-values-line"></div>
      <div className="corporate-values-grid">
        {valores.map((valor, index) => (
          <div key={index} className="corporate-values-card">
            <div className="corporate-values-icon">{valor.icono}</div>
            <h3 className="corporate-values-name">{valor.titulo}</h3>
            <p className="corporate-values-desc">{valor.descripcion}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default CorporateValues